import { STOCK_TAKING_CAR_MANAGEMENT_CLEAR_REPORT_STATE } from './constants'

export function clearReport() {
  return async dispatch => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_CLEAR_REPORT_STATE
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGEMENT_CLEAR_REPORT_STATE:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          reportError: null,
          reportSuccess: false,
          reportPending: false,
        }
      }
    default:
      return state
  }
}
